// extracted by mini-css-extract-plugin
module.exports = {"lds-heart":"spinner_lds-heart__3FCvQ","ldsHeart":"spinner_lds-heart__3FCvQ"};
    if(module.hot) {
      // 1783592040171
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  